export default __webpack_public_path__ + "static/media/AnimalGame_16.3856697f.png";